// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26u6c","colMin":"styles_colMin__3eyN_"};